import React from 'react';
import {connect} from 'react-redux';
import {DashboardLayout} from '../../components';
import {SubDomainSettingsLayout} from '../../components/SubDomainSideBars';

function SettingsLayout({children, breadCrumbs, hideSub}) {
  return (
    <DashboardLayout
      breadCrumbs={
        <p className="text-tiny font-normal text-deepBlue">{breadCrumbs}</p>
      }
    >
      {!hideSub ? <SubDomainSettingsLayout /> : <div className="mb-20"></div>}

      {children}
    </DashboardLayout>
  );
}

export default connect(state => state, null)(SettingsLayout);
